var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 196,
    viewBox: "0 0 252 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212.6 104.6V114L131.8 160.6L51 114V104.6H212.6Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 151.3L51 104.6L131.8 58L212.6 104.6L131.8 151.3Z",
    fill: "#26A092"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 150.2L52 104.1L51 104.6L131.8 151.3L212.6 104.6L211.6 104.1L131.8 150.2Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 140.5L69.7 104.7L131.8 68.7998L193.9 104.7L131.8 140.5Z",
    fill: "#013F37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.8 140.5L69.7 104.7L131.8 68.7998L193.9 104.7L131.8 140.5Z",
    fill: "url(#paint1_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.8 59.7002L193.9 95.6002V104.7L131.8 68.8002V59.7002Z",
    fill: "url(#paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.8 68.8002L69.7 104.7V95.6002L131.8 59.7002V68.8002Z",
    fill: "url(#paint3_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.8 131.5L69.7 95.6002L131.8 59.7002L193.9 95.6002L131.8 131.5Z",
    fill: "url(#paint4_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.8 109.9L107 95.5998L131.8 81.2998L156.6 95.5998L131.8 109.9Z",
    fill: "#59CCBE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.8 82.5998L155.5 96.2998L156.6 95.5998L131.8 81.2998L107 95.5998L108.1 96.2998L131.8 82.5998Z",
    fill: "#59CCBE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.8 131.501V140.501L193.9 104.701V95.6006L131.8 131.501Z",
    fill: "url(#paint5_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M69.7 95.6006V104.701L131.8 140.501V131.501L69.7 95.6006Z",
    fill: "url(#paint6_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M131.8 130.501L70.5 95.1006L69.7 95.6006L131.8 131.501L193.9 95.6006L193.1 95.1006L131.8 130.501Z",
    fill: "#59CCBE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M54 74.1002L39 65.4002L54 56.7002L69.1 65.4002L54 74.1002Z",
    fill: "#2D2D2D",
    fillOpacity: 0.67
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54 43.4998L39 34.7998V52.1998L54 60.8998L69.1 52.1998V34.7998L54 43.4998Z",
    fill: "#59CCBE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54 60.8998L39 52.1998V34.7998L54 43.4998V60.8998Z",
    fill: "#59CCBE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1 52.1998L54 60.8998V43.4998L69.1 34.7998V52.1998Z",
    fill: "#12B7A5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54 43.4996L39 34.7996L54 26.0996L69.1 34.7996L54 43.4996Z",
    fill: "#59CCBE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54 41.4002L42.7 34.8002L54 28.2002L65.4 34.8002L54 41.4002Z",
    fill: "#12B7A3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54 43.4998L39 34.7998V35.5998L54 44.2998L69.1 35.5998V34.7998L54 43.4998Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M54 17.4002L39 8.7002V26.1002L54 34.8002L69.1 26.1002V8.7002L54 17.4002Z",
    fill: "#59CCBE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54 34.8002L39 26.1002V8.7002L54 17.4002V34.8002Z",
    fill: "#59CCBE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1 26.1002L54 34.8002V17.4002L69.1 8.7002V26.1002Z",
    fill: "#12B7A5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M54 17.4L39 8.7L54 0L69.1 8.7L54 17.4Z",
    fill: "#59CCBE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M54 17.4002L39 8.7002V9.5002L54 18.2002L69.1 9.5002V8.7002L54 17.4002Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M236.4 81.0992L221.3 72.3992L236.4 63.6992L251.4 72.3992L236.4 81.0992Z",
    fill: "#2D2D2D",
    fillOpacity: 0.67
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M236.4 50.4998L221.3 41.7998V59.1998L236.4 67.8998L251.4 59.1998V41.7998L236.4 50.4998Z",
    fill: "#59CCBE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M236.4 67.8998L221.3 59.1998V41.7998L236.4 50.4998V67.8998Z",
    fill: "#59CCBE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M251.4 59.1998L236.4 67.8998V50.4998L251.4 41.7998V59.1998Z",
    fill: "#12B7A5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M236.4 50.4996L221.3 41.7996L236.4 33.0996L251.4 41.7996L236.4 50.4996Z",
    fill: "#59CCBE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M236.4 50.4998L221.3 41.7998V42.5998L236.4 51.2998L251.4 42.5998V41.7998L236.4 50.4998Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.1 126.099L0.100006 117.399L15.1 108.699L30.2 117.399L15.1 126.099Z",
    fill: "#2D2D2D",
    fillOpacity: 0.67
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 95.4998L0.100006 86.7998V104.2L15.1 112.9L30.2 104.2V86.7998L15.1 95.4998Z",
    fill: "#59CCBE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 112.9L0.100006 104.2V86.7998L15.1 95.4998V112.9Z",
    fill: "#59CCBE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2 104.2L15.1 112.9V95.4998L30.2 86.7998V104.2Z",
    fill: "#12B7A5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 95.4996L0.100006 86.7996L15.1 78.0996L30.2 86.7996L15.1 95.4996Z",
    fill: "#59CCBE"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 95.4998L0.100006 86.7998V87.4998L15.1 96.1998L30.2 87.4998V86.7998L15.1 95.4998Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M230 144L215 135.3L230 126.6L245.1 135.3L230 144Z",
    fill: "#2D2D2D",
    fillOpacity: 0.67
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M230 113.4L215 104.7V122.1L230 130.8L245.1 122.1V104.7L230 113.4Z",
    fill: "#59CCBE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M230 130.8L215 122.1V104.7L230 113.4V130.8Z",
    fill: "#59CCBE"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M245.1 122.1L230 130.8V113.4L245.1 104.7V122.1Z",
    fill: "#12B7A5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M230 113.4L215 104.7L230 96L245.1 104.7L230 113.4Z",
    fill: "#59CCBE"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M230 113.4L215 104.7V105.4L230 114.1L245.1 105.4V104.7L230 113.4Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M132 196L117 187.3L132 178.6L147.1 187.3L132 196Z",
    fill: "#2D2D2D",
    fillOpacity: 0.67
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M132 165.4L117 156.7V174.1L132 182.8L147.1 174.1V156.7L132 165.4Z",
    fill: "#59CCBE"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M132 182.8L117 174.1V156.7L132 165.4V182.8Z",
    fill: "#59CCBE"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M147.1 174.1L132 182.8V165.4L147.1 156.7V174.1Z",
    fill: "#12B7A5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M132 165.4L117 156.7L132 148L147.1 156.7L132 165.4Z",
    fill: "#59CCBE"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M132 165.4L117 156.7V157.4L132 166.1L147.1 157.4V156.7L132 165.4Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 64.1004L116.7 55.4004V72.8004L131.8 81.5004L146.9 72.8004V55.4004L131.8 64.1004Z",
    fill: "#59CCBE"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 81.5004L116.7 72.8004V55.4004L131.8 64.1004V81.5004Z",
    fill: "#59CCBE"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M146.9 72.8004L131.8 81.5004V64.1004L146.9 55.4004V72.8004Z",
    fill: "#12B7A3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 64.1002L116.7 55.4002L131.8 46.7002L146.9 55.4002L131.8 64.1002Z",
    fill: "#59CCBE"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 64.1002L117.4 55.7002L116.7 56.1002L131.8 64.8002L146.9 56.1002L146.2 55.8002L131.8 64.1002Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 75.2L136.3 66.5V83.9L151.4 92.6L166.4 83.9V66.5L151.4 75.2Z",
    fill: "#59CCBE"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 92.6L136.3 83.9V66.5L151.4 75.2V92.6Z",
    fill: "#59CCBE"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M166.4 83.9L151.4 92.6V75.2L166.4 66.5V83.9Z",
    fill: "#12B7A3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 75.1998L136.3 66.4998L151.4 57.7998L166.4 66.4998L151.4 75.1998Z",
    fill: "#59CCBE"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 75.1994L137 66.8994L136.3 67.2994L151.4 75.9994L166.4 67.2994L165.8 66.8994L151.4 75.1994Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M170.9 86.4002L155.9 77.7002V95.1002L170.9 103.8L186 95.1002V77.7002L170.9 86.4002Z",
    fill: "#59CCBE"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M170.9 103.8L155.9 95.1002V77.7002L170.9 86.4002V103.8Z",
    fill: "#59CCBE"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M186 95.1002L170.9 103.8V86.4002L186 77.7002V95.1002Z",
    fill: "#12B7A3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M170.9 86.4L155.9 77.7L170.9 69L186 77.7L170.9 86.4Z",
    fill: "#59CCBE"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M170.9 86.4002L156.5 78.1002L155.9 78.5002L170.9 87.2002L186 78.5002V77.7002L170.9 86.4002Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 75.9998L97.2 67.2998V84.6998L112.2 93.3998L127.3 84.6998V67.2998L112.2 75.9998Z",
    fill: "#59CCBE"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 93.3998L97.2 84.6998V67.2998L112.2 75.9998V93.3998Z",
    fill: "#59CCBE"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M127.3 84.6998L112.2 93.3998V75.9998L127.3 67.2998V84.6998Z",
    fill: "#12B7A3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 75.9996L97.2 67.2996L112.2 58.5996L127.3 67.2996L112.2 75.9996Z",
    fill: "#59CCBE"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 75.9992L97.8 67.6992L97.2 67.9992L112.2 76.6992L127.3 67.9992L126.6 67.6992L112.2 75.9992Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 87.2L116.7 78.5V95.9L131.8 104.6L146.9 95.9V78.5L131.8 87.2Z",
    fill: "#59CCBE"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 104.6L116.7 95.9V78.5L131.8 87.2V104.6Z",
    fill: "#59CCBE"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M146.9 95.9L131.8 104.6V87.2L146.9 78.5V95.9Z",
    fill: "#12B7A3"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 87.1998L116.7 78.4998L131.8 69.7998L146.9 78.4998L131.8 87.1998Z",
    fill: "#59CCBE"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 87.1998L117.4 78.7998L116.7 79.1998L131.8 87.8998L146.9 79.1998L146.2 78.7998L131.8 87.1998Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 98.3006L136.3 89.6006V107.001L151.4 115.701L166.4 107.001V89.6006L151.4 98.3006Z",
    fill: "#59CCBE"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 115.701L136.3 107.001V89.6006L151.4 98.3006V115.701Z",
    fill: "#59CCBE"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M166.4 107.001L151.4 115.701V98.3006L166.4 89.6006V107.001Z",
    fill: "#12B7A3"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 98.3004L136.3 89.6004L151.4 80.9004L166.4 89.6004L151.4 98.3004Z",
    fill: "#59CCBE"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 98.3006L137 90.0006L136.3 90.4006L151.4 99.1006L166.4 90.4006V89.6006L151.4 98.3006Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7 87.9002L77.6 79.2002V96.6002L92.7 105.3L107.7 96.6002V79.2002L92.7 87.9002Z",
    fill: "#59CCBE"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7 105.3L77.6 96.6002V79.2002L92.7 87.9002V105.3Z",
    fill: "#59CCBE"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M107.7 96.6002L92.7 105.3V87.9002L107.7 79.2002V96.6002Z",
    fill: "#12B7A3"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7 87.9L77.6 79.2L92.7 70.5L107.7 79.2L92.7 87.9Z",
    fill: "#59CCBE"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7 87.9002L77.6 79.2002V80.0002L92.7 88.7002L107.7 80.0002L107.1 79.6002L92.7 87.9002Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 99.1004L97.2 90.4004V107.8L112.2 116.5L127.3 107.8V90.4004L112.2 99.1004Z",
    fill: "#59CCBE"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 116.5L97.2 107.8V90.4004L112.2 99.1004V116.5Z",
    fill: "#59CCBE"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M127.3 107.8L112.2 116.5V99.1004L127.3 90.4004V107.8Z",
    fill: "#12B7A3"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 99.1002L97.2 90.4002L112.2 81.7002L127.3 90.4002L112.2 99.1002Z",
    fill: "#59CCBE"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 99.1004L97.2 90.4004V91.1004L112.2 99.8004L127.3 91.1004L126.6 90.8004L112.2 99.1004Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 110.301L116.7 101.601V118.901L131.8 127.601L146.9 118.901V101.601L131.8 110.301Z",
    fill: "#59CCBE"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 127.601L116.7 118.901V101.601L131.8 110.301V127.601Z",
    fill: "#59CCBE"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M146.9 118.901L131.8 127.601V110.301L146.9 101.601V118.901Z",
    fill: "#12B7A3"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 110.3L116.7 101.6L131.8 92.9004L146.9 101.6L131.8 110.3Z",
    fill: "#59CCBE"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 110.301L116.7 101.601V102.301L131.8 111.001L146.9 102.301V101.601L131.8 110.301Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 40.9998L116.7 32.2998V49.6998L131.8 58.3998L146.9 49.6998V32.2998L131.8 40.9998Z",
    fill: "#59CCBE"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 58.3998L116.7 49.6998V32.2998L131.8 40.9998V58.3998Z",
    fill: "#59CCBE"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M146.9 49.6998L131.8 58.3998V40.9998L146.9 32.2998V49.6998Z",
    fill: "#12B7A3"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 40.9996L116.7 32.2996L131.8 23.5996L146.9 32.2996L131.8 40.9996Z",
    fill: "#59CCBE"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 40.9992L117.4 32.6992L116.7 32.9992L131.8 41.6992L146.9 32.9992L146.2 32.6992L131.8 40.9992Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M131.8 107.4L121.5 101.5L131.8 95.5L142.1 101.5L131.8 107.4Z",
    fill: "#12AEA0"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M112.2 96.1994L102 90.2994L112.2 84.3994L122.5 90.2994L112.2 96.1994Z",
    fill: "#12AEA0"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M151.4 95.4996L141.1 89.5996L151.4 83.5996L161.7 89.5996L151.4 95.4996Z",
    fill: "#12AEA0"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M171 83.6998L160.7 77.7998L171 71.7998L181.3 77.7998L171 83.6998Z",
    fill: "#12AEA0"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M92.7 85.1002L82.4 79.1002L92.7 73.2002L102.9 79.1002L92.7 85.1002Z",
    fill: "#12AEA0"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 52.2L136.3 43.5V60.8L151.4 69.5L166.4 60.8V43.5L151.4 52.2Z",
    fill: "#59CCBE"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 69.5L136.3 60.8V43.5L151.4 52.2V69.5Z",
    fill: "#59CCBE"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M166.4 60.8L151.4 69.5V52.2L166.4 43.5V60.8Z",
    fill: "#12B7A3"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 52.1998L136.3 43.4998L151.4 34.7998L166.4 43.4998L151.4 52.1998Z",
    fill: "#59CCBE"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 52.1998L137 43.7998L136.3 44.1998L151.4 52.8998L166.4 44.1998L165.8 43.7998L151.4 52.1998Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M170.9 63.3006L155.9 54.6006V72.0006L170.9 80.7006L186 72.0006V54.6006L170.9 63.3006Z",
    fill: "#59CCBE"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M170.9 80.7006L155.9 72.0006V54.6006L170.9 63.3006V80.7006Z",
    fill: "#59CCBE"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M186 72.0006L170.9 80.7006V63.3006L186 54.6006V72.0006Z",
    fill: "#12B7A3"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M170.9 63.3004L155.9 54.6004L170.9 45.9004L186 54.6004L170.9 63.3004Z",
    fill: "#59CCBE"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M170.9 63.3006L156.5 55.0006L155.9 55.4006L170.9 64.1006L186 55.4006V54.6006L170.9 63.3006Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 52.9002L97.2 44.2002V61.6002L112.2 70.3002L127.3 61.6002V44.2002L112.2 52.9002Z",
    fill: "#59CCBE"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 70.3002L97.2 61.6002V44.2002L112.2 52.9002V70.3002Z",
    fill: "#59CCBE"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M127.3 61.6002L112.2 70.3002V52.9002L127.3 44.2002V61.6002Z",
    fill: "#12B7A3"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 52.9L97.2 44.2L112.2 35.5L127.3 44.2L112.2 52.9Z",
    fill: "#59CCBE"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 52.8996L97.8 44.5996L97.2 44.9996L112.2 53.6996L127.3 44.9996L126.6 44.5996L112.2 52.8996Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 64.1004L116.7 55.4004V72.8004L131.8 81.5004L146.9 72.8004V55.4004L131.8 64.1004Z",
    fill: "#59CCBE"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 81.5004L116.7 72.8004V55.4004L131.8 64.1004V81.5004Z",
    fill: "#59CCBE"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M146.9 72.8004L131.8 81.5004V64.1004L146.9 55.4004V72.8004Z",
    fill: "#12B7A3"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 64.1002L116.7 55.4002L131.8 46.7002L146.9 55.4002L131.8 64.1002Z",
    fill: "#59CCBE"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 64.0998L117.4 55.7998L116.7 56.0998L131.8 64.7998L146.9 56.0998L146.2 55.7998L131.8 64.0998Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 75.2L136.3 66.5V83.9L151.4 92.6L166.4 83.9V66.5L151.4 75.2Z",
    fill: "#59CCBE"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 92.6L136.3 83.9V66.5L151.4 75.2V92.6Z",
    fill: "#59CCBE"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M166.4 83.9L151.4 92.6V75.2L166.4 66.5V83.9Z",
    fill: "#12B7A3"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 75.1998L136.3 66.4998L151.4 57.7998L166.4 66.4998L151.4 75.1998Z",
    fill: "#59CCBE"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 75.2L137 66.9L136.3 67.3L151.4 76L166.4 67.3V66.5L151.4 75.2Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7 64.8006L77.6 56.1006V73.5006L92.7 82.2006L107.7 73.5006V56.1006L92.7 64.8006Z",
    fill: "#59CCBE"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7 82.2006L77.6 73.5006V56.1006L92.7 64.8006V82.2006Z",
    fill: "#59CCBE"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M107.7 73.5006L92.7 82.2006V64.8006L107.7 56.1006V73.5006Z",
    fill: "#12B7A3"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7 64.8004L77.6 56.1004L92.7 47.4004L107.7 56.1004L92.7 64.8004Z",
    fill: "#59CCBE"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7 64.8L78.2 56.5L77.6 56.9L92.7 65.6L107.7 56.9L107.1 56.5L92.7 64.8Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 75.9998L97.2 67.2998V84.6998L112.2 93.3998L127.3 84.6998V67.2998L112.2 75.9998Z",
    fill: "#59CCBE"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 93.3998L97.2 84.6998V67.2998L112.2 75.9998V93.3998Z",
    fill: "#59CCBE"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M127.3 84.6998L112.2 93.3998V75.9998L127.3 67.2998V84.6998Z",
    fill: "#12B7A3"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 75.9996L97.2 67.2996L112.2 58.5996L127.3 67.2996L112.2 75.9996Z",
    fill: "#59CCBE"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 75.9998L97.2 67.2998V67.9998L112.2 76.6998L127.3 67.9998L126.6 67.6998L112.2 75.9998Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 87.2L116.7 78.5V95.9L131.8 104.6L146.9 95.9V78.5L131.8 87.2Z",
    fill: "#59CCBE"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 104.6L116.7 95.9V78.5L131.8 87.2V104.6Z",
    fill: "#59CCBE"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M146.9 95.9L131.8 104.6V87.2L146.9 78.5V95.9Z",
    fill: "#12B7A3"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 87.1998L116.7 78.4998L131.8 69.7998L146.9 78.4998L131.8 87.1998Z",
    fill: "#59CCBE"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 87.2L116.7 78.5V79.2L131.8 87.9L146.9 79.2V78.5L131.8 87.2Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M171 60.7004L160.7 54.8004L171 48.9004L181.3 54.8004L171 60.7004Z",
    fill: "#12AEA0"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M92.7 62.1002L82.4 56.2002L92.7 50.2002L102.9 56.2002L92.7 62.1002Z",
    fill: "#12AEA0"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 17.9002L116.7 9.2002V26.6002L131.8 35.3002L146.9 26.6002V9.2002L131.8 17.9002Z",
    fill: "#59CCBE"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 35.3002L116.7 26.6002V9.2002L131.8 17.9002V35.3002Z",
    fill: "#59CCBE"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M146.9 26.6002L131.8 35.3002V17.9002L146.9 9.2002V26.6002Z",
    fill: "#12B7A3"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 17.9L116.7 9.2L131.8 0.5L146.9 9.2L131.8 17.9Z",
    fill: "#59CCBE"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 17.9002L116.7 9.2002V9.9002L131.8 18.6002L146.9 9.9002V9.2002L131.8 17.9002Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 29.1004L136.3 20.4004V37.8004L151.4 46.5004L166.4 37.8004V20.4004L151.4 29.1004Z",
    fill: "#59CCBE"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 46.5004L136.3 37.8004V20.4004L151.4 29.1004V46.5004Z",
    fill: "#59CCBE"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M166.4 37.8004L151.4 46.5004V29.1004L166.4 20.4004V37.8004Z",
    fill: "#12B7A3"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 29.1002L136.3 20.4002L151.4 11.7002L166.4 20.4002L151.4 29.1002Z",
    fill: "#59CCBE"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M151.4 29.1004L136.3 20.4004V21.1004L151.4 29.8004L166.4 21.1004V20.4004L151.4 29.1004Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M170.9 40.2L155.9 31.5V48.9L170.9 57.6L186 48.9V31.5L170.9 40.2Z",
    fill: "#59CCBE"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M170.9 57.6L155.9 48.9V31.5L170.9 40.2V57.6Z",
    fill: "#59CCBE"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M186 48.9L170.9 57.6V40.2L186 31.5V48.9Z",
    fill: "#12B7A3"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M170.9 40.1998L155.9 31.4998L170.9 22.7998L186 31.4998L170.9 40.1998Z",
    fill: "#59CCBE"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M170.9 40.2L155.9 31.5V32.3L170.9 41L186 32.3V31.5L170.9 40.2Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 29.8006L97.2 21.1006V38.5006L112.2 47.2006L127.3 38.5006V21.1006L112.2 29.8006Z",
    fill: "#59CCBE"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 47.2006L97.2 38.5006V21.1006L112.2 29.8006V47.2006Z",
    fill: "#59CCBE"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M127.3 38.5006L112.2 47.2006V29.8006L127.3 21.1006V38.5006Z",
    fill: "#12B7A3"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 29.8004L97.2 21.1004L112.2 12.4004L127.3 21.1004L112.2 29.8004Z",
    fill: "#59CCBE"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2 29.8006L97.2 21.1006V21.9006L112.2 30.6006L127.3 21.9006V21.1006L112.2 29.8006Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7 41.7L77.6 33V50.4L92.7 59.1L107.7 50.4V33L92.7 41.7Z",
    fill: "#59CCBE"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7 59.1L77.6 50.4V33L92.7 41.7V59.1Z",
    fill: "#59CCBE"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M107.7 50.4L92.7 59.1V41.7L107.7 33V50.4Z",
    fill: "#12B7A3"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7 41.6998L77.6 32.9998L92.7 24.2998L107.7 32.9998L92.7 41.6998Z",
    fill: "#59CCBE"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7 41.7L77.6 33V33.8L92.7 42.5L107.7 33.8V33L92.7 41.7Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 11.0978,
    y1: 132.63,
    x2: 218.094,
    y2: 132.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C9F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#31AC9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6924,
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CCBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 69.6781,
    y1: 104.659,
    x2: 193.923,
    y2: 104.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#59CCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 131.8,
    y1: 82.2044,
    x2: 193.923,
    y2: 82.2044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#59CCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 69.6781,
    y1: 82.2039,
    x2: 131.801,
    y2: 82.2039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#59CCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 69.6781,
    y1: 95.6154,
    x2: 193.923,
    y2: 95.6154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#59CCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 131.801,
    y1: 118.071,
    x2: 193.923,
    y2: 118.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#59CCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 69.6781,
    y1: 118.071,
    x2: 131.801,
    y2: 118.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3285,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "#59CCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7209,
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#258D81"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.ec718342f13c705cd1e8bc55048c5fc9.svg";
export { ForwardRef as ReactComponent };